import { resolveBackendApiBaseUrl } from './backend-api-url';

export const environment = {
  production: false,
  backendApiBaseUrl: resolveBackendApiBaseUrl(),
  serviceWorkerEnabled: true,
  appVersion: '1.0.0',
};
